import { render, staticRenderFns } from "./team-admin-detail.vue?vue&type=template&id=3dce6834&scoped=true&"
import script from "./team-admin-detail.vue?vue&type=script&lang=js&"
export * from "./team-admin-detail.vue?vue&type=script&lang=js&"
import style0 from "./team-admin-detail.vue?vue&type=style&index=0&id=3dce6834&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dce6834",
  null
  
)

export default component.exports